import React from 'react';
import SEO from '../components/SEO';
import JobsBoardHeroSection from '../components/jobs/JobsBoardHeroSection';
import JobsOpenRolesSection from '../components/jobs/JobsOpenRolesSection';
import JobsDirectionCtaSection from '../components/jobs/JobsDirectionCtaSection';

function Jobs() {
  return (
    <main style={{ background: '#0b2238', color: '#eef4fa', minHeight: '100vh' }}>
      <SEO
        title="Jobs | Lead With Tech"
        description="Explore open roles and opportunities at Lead With Tech."
      />

      <JobsBoardHeroSection />
      <JobsOpenRolesSection />
      <JobsDirectionCtaSection />
    </main>
  );
}

export default Jobs;
